import { OrderType } from '@shared/utils/Trading/OrderType';
import { OrderStatus } from '@shared/utils/Trading/OrderStatus';
import { OperationType } from '@shared/utils/Trading/OperationType';
import { OrderTif, OrderTifMap } from '@shared/utils/Trading/OrderTifEnum';
export class _TvOrderConvertor {
    getTvOrderType(orderType) {
        switch (orderType) {
            case OrderType.Market:
                return 2 /* tvOrderType.Market */;
            case OrderType.Stop:
            case OrderType.SLTPStop:
            case OrderType.TRStop:
                return 3 /* tvOrderType.Stop */;
            case OrderType.Limit:
            case OrderType.SLTPLimit:
                return 1 /* tvOrderType.Limit */;
            case OrderType.StopLimit:
                return 4 /* tvOrderType.StopLimit */;
            case OrderType.Manual:
            case OrderType.OCO:
            default:
                throw new Error(`[TvOrderConvertor::getOrderType]: OrderType ${orderType} not supported`);
        }
    }
    getRealOrderType(orderType) {
        switch (orderType) {
            case 2 /* tvOrderType.Market */:
                return OrderType.Market;
            case 3 /* tvOrderType.Stop */:
                return OrderType.Stop;
            case 1 /* tvOrderType.Limit */:
                return OrderType.Limit;
            case 4 /* tvOrderType.StopLimit */:
                return OrderType.StopLimit;
            // OrderType.SLTPStop:
            // OrderType.TRStop:
            // case OrderType.SLTPLimit:
            // OrderType.Manual:
            // OrderType.TRStop:
            // OrderType.OCO:
            default:
                throw new Error(`[TvOrderConvertor::getRealOrderType]: OrderType ${orderType} not supported`);
        }
    }
    getTvOrderStatus(orderStatus) {
        switch (orderStatus) {
            case OrderStatus.PENDING_NEW:
            case OrderStatus.WAITING_MARKET:
            case OrderStatus.OFF_MARKET:
                return 4 /* tvOrderStatus.Placing */;
            case OrderStatus.NEW:
                return 6 /* tvOrderStatus.Working */;
            case OrderStatus.CANCELED:
                return 1 /* tvOrderStatus.Canceled */;
            case OrderStatus.FILLED:
                return 2 /* tvOrderStatus.Filled */;
            case OrderStatus.REFUSED:
                return 5 /* tvOrderStatus.Rejected */;
            // tvOrderStatus.Inactive - уточнить у аналитика
            default:
                return 6 /* tvOrderStatus.Working */;
        }
    }
    getTvOrderSide(side) {
        return side === OperationType.Buy ? 1 /* Side.Buy */ : -1 /* Side.Sell */;
    }
    getTvOrderDuration(tif, expiration) {
        if (tif === OrderTif.GTD) {
            return {
                type: OrderTifMap[OrderTif.GTD],
                datetime: expiration.getTime()
            };
        }
        const duration = {
            type: OrderTifMap[tif]
        };
        return duration;
    }
}
export const TvOrderConvertor = new _TvOrderConvertor();
